import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { thunk } from "redux-thunk";
import { reducers, ApplicationState } from ".";

export default function configureStore(initialState: ApplicationState) {
  const middleware = [thunk];

  const rootReducer = combineReducers({
    ...reducers,
  });

  // In development, use the browser's Redux dev tools extension if installed
  const isDevelopment = import.meta.env.MODE === "development";
  const composeEnhancers =
    isDevelopment &&
    typeof window !== "undefined" &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;

  return createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware)),
  );
}
